"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const apiType_1 = require("../apiType");
const exception_1 = require("@almservices-cl/exception");
exports.default = (typeValue, host) => {
    if (typeValue === apiType_1.apiType.PBP_10 && host === undefined) {
        throw new exception_1.BadMethodCallException("Host has be defined on production mode!");
    }
};
//# sourceMappingURL=assertPBPProductionHost.js.map